// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cookieToggle-module--wrapper--2quTx","text":"cookieToggle-module--text--IPh5E"};